import { lazy } from 'react';

export { default as routes } from './routes';

export const ClusterOperationFeature = lazy(() => import('./pages/ClusterOperationFeature'));
